import { PageHeader } from "@components/kit/page-header";
import { Button } from "@components/ui/interactive/button";
import { Container } from "@components/ui/structure/container";
import { LoadingView } from "@components/view/loading-view";
import { useDataAccess } from "@contexts/data-access";
import { useClasses } from "@styles";

export function DataAccessView() {
  const { ready, tables, download } = useDataAccess();

  if (!ready)
    return <LoadingView />;

  return (<>
    <Container className={useClasses("home-view-content")}>
      <PageHeader
        icon="DatabaseRegular"
        title="Data Access"
      />

      <Container className={useClasses("home-view-links")}>
        {tables.map(table => <Button
          icon="DatabaseExportRegular"
          title={table.friendlyName}
          hoverText="Download CSV"
          onClick={() => download(table.name)}
        />)}

        {[...Array(6)].map(c => <Container children={null} />)}
      </Container>
    </Container>
  </>);
}

